import { render, staticRenderFns } from "./ques7.vue?vue&type=template&id=24747cb0"
import script from "./ques7.vue?vue&type=script&lang=js"
export * from "./ques7.vue?vue&type=script&lang=js"
import style0 from "./ques7.vue?vue&type=style&index=0&id=24747cb0&prod&lang=css"
import style1 from "./ques7.vue?vue&type=style&index=1&id=24747cb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports